import React, { useState } from "react";

const questionsDB = {
    "Dolor de cabeza": [
        {
            question: "¿En qué parte siente el dolor?",
            options: ["Frontal", "Temporal", "Occipital", "Generalizado"],
        },
        {
            question: "¿Cómo describiría el dolor?",
            options: ["Punzante", "Opresivo", "Palpitante", "Sordo"],
        },
    ],
    "Fiebre alta": [
        {
            question: "¿Desde cuándo tiene fiebre?",
            options: ["Menos de 1 día", "1-3 días", "Más de 3 días", "No lo sé"],
        },
        {
            question: "¿Tiene escalofríos?",
            options: ["Sí", "No", "A veces", "No lo sé"],
        },
    ],
    "Tos seca": [
        {
            question: "¿La tos es constante?",
            options: ["Sí", "No", "Sólo por la noche", "No lo sé"],
        },
        {
            question: "¿Siente dolor al toser?",
            options: ["Sí", "No", "A veces", "No lo sé"],
        },
    ],
    "Dolor muscular": [
        {
            question: "¿Dónde siente el dolor muscular?",
            options: ["Piernas", "Brazos", "Espalda", "Generalizado"],
        },
        {
            question: "¿El dolor es intenso?",
            options: ["Sí", "No", "Moderado", "Variable"],
        },
    ],
    "Fatiga excesiva": [
        {
            question: "¿Desde cuándo siente fatiga?",
            options: ["Menos de 1 día", "1-3 días", "Más de 3 días", "No lo sé"],
        },
        {
            question: "¿Le afecta para realizar actividades?",
            options: ["Sí", "No", "A veces", "No lo sé"],
        },
    ],
    "Congestión nasal": [
        {
            question: "¿La congestión es constante?",
            options: ["Sí", "No", "Sólo por la noche", "No lo sé"],
        },
        {
            question: "¿Tiene secreción nasal?",
            options: ["Sí", "No", "A veces", "No lo sé"],
        },
    ],
};

const SymptomQuestions = ({ symptoms, onFinish, onComplete }) => {
    const [currentSymptomIndex, setCurrentSymptomIndex] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState({});

    const symptom = symptoms[currentSymptomIndex];
    const questions = questionsDB[symptom] || [];
    const questionObj = questions[currentQuestionIndex];

    const handleAnswer = (answer) => {
        setAnswers((prev) => {
            const newAnswers = {
                ...prev,
                [symptom]: {
                    ...(prev[symptom] || {}),
                    [questionObj.question]: answer,
                },
            };
            if (onFinish) onFinish(newAnswers); // Si quieres actualizar respuestas parciales
            return newAnswers;
        });
    };

    const goNext = () => {
        if (!answers[symptom] || !answers[symptom][questionObj.question]) {
            alert("Por favor, responde la pregunta antes de continuar.");
            return;
        }

        if (currentQuestionIndex + 1 < questions.length) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else if (currentSymptomIndex + 1 < symptoms.length) {
            setCurrentSymptomIndex(currentSymptomIndex + 1);
            setCurrentQuestionIndex(0);
        } else {
            // Aquí se terminó el cuestionario, avisamos al padre
            if (onComplete) onComplete(answers);
            alert("Cuestionario finalizado.");
        }
    };

    const goBack = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        } else if (currentSymptomIndex > 0) {
            const prevSymptom = symptoms[currentSymptomIndex - 1];
            setCurrentSymptomIndex(currentSymptomIndex - 1);
            setCurrentQuestionIndex((questionsDB[prevSymptom]?.length || 1) - 1);
        }
    };

    if (symptoms.length === 0) {
        return <p>Por favor, agrega síntomas para comenzar el cuestionario.</p>;
    }

    return (
        <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <h3 style={{ textAlign: "center", marginBottom: "15px" }}>
                Pregunta sobre: {symptom}
            </h3>
            <p style={{ fontWeight: "bold" }}>{questionObj.question}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {questionObj.options.map((option, i) => (
                    <label key={i} style={{ cursor: "pointer" }}>
                        <input
                            type="radio"
                            name={`question-${currentSymptomIndex}-${currentQuestionIndex}`}
                            value={option}
                            checked={
                                answers[symptom]?.[questionObj.question] === option || false
                            }
                            onChange={() => handleAnswer(option)}
                            style={{ marginRight: "8px" }}
                        />
                        {option}
                    </label>
                ))}
            </div>
            <div
                style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <button
                    onClick={goBack}
                    disabled={currentSymptomIndex === 0 && currentQuestionIndex === 0}
                    style={{
                        padding: "10px 15px",
                        borderRadius: "8px",
                        cursor:
                            currentSymptomIndex === 0 && currentQuestionIndex === 0
                                ? "not-allowed"
                                : "pointer",
                    }}
                >
                    Atrás
                </button>
                <button
                    onClick={goNext}
                    style={{
                        padding: "10px 15px",
                        borderRadius: "8px",
                        backgroundColor:
                            currentSymptomIndex === symptoms.length - 1 &&
                            currentQuestionIndex === questions.length - 1
                                ? "#28a745"
                                : "#007bff",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    {currentSymptomIndex === symptoms.length - 1 &&
                    currentQuestionIndex === questions.length - 1
                        ? "Finalizar"
                        : "Siguiente"}
                </button>
            </div>
        </div>
    );
};

export default SymptomQuestions;
